import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ReportTable, TotalsBar, money, Empty } from "./ReportTables";

export const PAYMENT_METHOD_OPTIONS = [
  { value: "cash_app", label: "Cash App" },
  { value: "zelle", label: "Zelle" },
  { value: "paypal", label: "PayPal" },
  { value: "stripe", label: "Stripe / Card" },
  { value: "check", label: "Check" },
  { value: "cash", label: "Cash" },
  { value: "other", label: "Other" },
];
const label = (v) => PAYMENT_METHOD_OPTIONS.find((m) => m.value === v)?.label || v;
const METHOD_CLASS = { cash_app: "bg-green-100 text-green-700", zelle: "bg-purple-100 text-purple-700", stripe: "bg-indigo-100 text-indigo-700", check: "bg-amber-100 text-amber-700", cash: "bg-lime-100 text-lime-700", other: "bg-slate-100 text-slate-700", paypal: "bg-sky-100 text-sky-800" };

const COLUMNS = [
  { key: "date", label: "Date", accessor: (p) => p.date, className: "whitespace-nowrap" },
  { key: "invoice_number", label: "Invoice #", accessor: (p) => p.invoice_number, className: "font-semibold text-slate-800" },
  { key: "customer_name", label: "Customer", accessor: (p) => p.customer_name },
  { key: "method", label: "Method", accessor: (p) => label(p.method), render: (p) => <Badge className={METHOD_CLASS[p.method] || METHOD_CLASS.other}>{label(p.method)}</Badge> },
  { key: "note", label: "Note", accessor: (p) => p.note || "", className: "text-slate-500 text-sm" },
  { key: "receipt", label: "Receipt", accessor: (p) => (p.receipt_to ? 1 : 0), render: (p) => (p.receipt_to ? <span className="text-xs text-green-700" title={p.receipt_sent_at}>Sent to {p.receipt_to}</span> : <span className="text-xs text-slate-400">—</span>) },
  { key: "amount", label: "Amount", accessor: (p) => p.amount, render: (p) => <span className="font-bold text-green-700">{money(p.amount)}</span>, align: "right" },
];

export const PaymentsReport = ({ data }) => {
  if (!data) return null;
  const { payments, totals, by_method, by_customer } = data;
  const top = by_customer[0];
  return (
    <div className="space-y-6" data-testid="payments-report">
      <TotalsBar cells={[
        { label: "Total Collected", value: money(totals.amount), cls: "text-green-700", testId: "payments-total" },
        { label: "Payments", value: totals.count, testId: "payments-count" },
        { label: "Average Payment", value: money(totals.count ? totals.amount / totals.count : 0), testId: "payments-average" },
        { label: "Top Customer", value: top ? top.customer_name : "—", cls: "text-slate-800 text-base truncate", testId: "payments-top-customer" },
      ]} />
      {by_method.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-6 gap-3" data-testid="payments-by-method">
          {by_method.map((m) => (
            <Card key={m.method} className="bg-white border-0 shadow"><CardContent className="p-3">
              <Badge className={METHOD_CLASS[m.method] || METHOD_CLASS.other}>{m.label}</Badge>
              <p className="text-lg font-bold text-slate-800 mt-2" data-testid={`payments-method-${m.method}`}>{money(m.amount)}</p>
              <p className="text-xs text-slate-500">{m.count} payment{m.count === 1 ? "" : "s"}</p>
            </CardContent></Card>
          ))}
        </div>
      )}
      {payments.length === 0 ? <Empty title="No payments in this period" /> : (
        <ReportTable rows={payments} columns={COLUMNS} defaultSort="date" rowKey={(p) => p.id} testId="payments-table"
          footer={{ date: "TOTAL", invoice_number: `${totals.count} payments`, amount: money(totals.amount) }} />
      )}
    </div>
  );
};
